import { render, staticRenderFns } from "./CentrumEdukacji.vue?vue&type=template&id=703d185e&scoped=true"
import script from "./CentrumEdukacji.vue?vue&type=script&lang=js"
export * from "./CentrumEdukacji.vue?vue&type=script&lang=js"
import style0 from "./CentrumEdukacji.vue?vue&type=style&index=0&id=703d185e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703d185e",
  null
  
)

export default component.exports